import getBase64Image from './getBase'
let e5Icons = {
  android: require('../assets/icons/android-icon.png'), // 安卓
  ios: require('../assets/icons/ios-icon.png'), // ios
  lock: require('../assets/icons/icon-lock.png'),
  forbidden: require('../assets/icons/forbidden.png'),
  startUsing: require('../assets/icons/startUsing.png'),
  channelInfo: require('../assets/icons/channelInfo.png'),
  flowRecord: require('../assets/icons/flowRecord.png'),
  modification: require('../assets/icons/modification.png'),
  sort: require('../assets/icons/sort.png'), // 推荐管理——排序
  download: require('../assets/icons/34.png'), // 下载
  detail: require('../assets/icons/detail.png'), // 操作的详情图标
  clue: require('../assets/icons/clue.png'), // 爆料转为线索
  trRefresh: require('../assets/icons/tr-refresh.png'), // table里的刷新
  no_result: require('../assets/icons/42.png'),
  copyright: require('../assets/icons/23.png'),
  top: require('../assets/icons/icon-top.png'),
  pushed: require('../assets/icons/push.png'),

  article: require('../assets/icons/icon-article.png'),
  video: require('../assets/icons/icon-video.png'),
  link: require('../assets/icons/icon-link.png'),
  pic: require('../assets/icons/icon-article-photo.png'),
  live: require('../assets/icons/59.png'), //  列表-直播
  special: require('../assets/icons/60.png'), //  列表-专题
  subject: require('../assets/icons/subject.png'), //  列表-话题
  activity: require('../assets/icons/activity.png'), //  列表-活动
  vote: require('../assets/icons/vote.png'),
  audio: require('../assets/icons/audio.png'),

  sen0: require('../assets/icons/sen0.png'), // 敏感词
  sen1: require('../assets/icons/sen1.png'), // 禁用词
  sen2: require('../assets/icons/sen2.png'), // 保留词
  sensitive: require('../assets/icons/sensitive.png'), // 敏感词
  illegal: require('../assets/icons/illegal.png'), // 禁用词
  senandill: require('../assets/icons/senandill.png'), // 禁用词和敏感词

  userColumnPermission: require('../assets/icons/user-column-permission.png'), //  操作栏目权限
  userDelete: require('../assets/icons/icon-upload-delete.png'), //  操作删除用户
  userDetail: require('../assets/icons/53.png'), //  操作用户详情
  userRoleConfig: require('../assets/icons/user-role-config.png'), //  操作角色设置

  appEdit: require('../assets/icons/topicEdit.png'), //  内容发布-修改
  appPreview: require('../assets/icons/appPreview.png'), //  内容发布-预览

  mamDetail: require('../assets/icons/mamDetail.png'), //  媒资-详情
  mamDelete: require('../assets/icons/mamDelete.png'), //  媒资-删除
  mamCheck: require('../assets/icons/mamCheck.png'), //  媒资-智能检测
  mamQuickEdit: require('../assets/icons/quickEdit.png'), // 快编

  tableDel: require('../assets/icons/mamDelete.png'), //  云端稿库-删除
  roleSet: require('../assets/icons/roleSet.png'), //  修改角色
  tableModify: require('../assets/icons/30.png'), //  修改用户

  discussReply: require('../assets/icons/discussReply.png'), //  评论管理-官方回复
  discussReject: require('../assets/icons/discussReject.png'), //  评论管理-不通过
  discussReplied: require('../assets/icons/discussReplied.png'), //  评论管理-官方回复-已回复
  discussPass: require('../assets/icons/discussPass.png'), //  评论管理-通过
  discussStatePass: require('../assets/icons/discussStatePass.png'), //  评论管理-状态-通过
  discussStatePendingApproval: require('../assets/icons/discussStatePendingApproval.png'), //  评论管理-状态-待审核
  discussStateReject: require('../assets/icons/discussStateReject.png'), //  评论管理-状态-不通过
  expose: require('../assets/icons/51.png'), // 被举报

  ucPreview: require('../assets/icons/appPreview.png'), //  会员-详情
  ucEdit: require('../assets/icons/topicEdit.png'), //  会员-修改
  ucDelete: require('../assets/icons/mamDelete.png'), //  会员-注销

  QAPass: require('../assets/icons/discussPass.png'), //  问政-状态-通过
  QAReject: require('../assets/icons/discussReject.png'), //  问政-不通过
  QAReply: require('../assets/icons/discussReply.png'), //  问政-官方回复

  voteDelete: require('../assets/icons/comDelete.png'), // 投票-删除
  voteEdit: require('../assets/icons/comEdit.png'), // 投票-修改
  votePreview: require('../assets/icons/comPreview.png'), // 投票-预览
  voteResult: require('../assets/icons/voteResult.png'), // 投票-投票结果

  preview: require('../assets/icons/appPreview.png'), //  通用预览
  config: require('../assets/icons/siteEdit.png'), //  通用设置
  deleteBlue: require('../assets/icons/topicDelete.png'), //  通用删除 蓝色小盖子

  audioCom: require('../assets/icons/audioCom.png'), // 云端稿库-音频稿件icon

  activityResult: require('../assets/icons/activityResult.png'), // 活动列表查看报名图标

  frozen: require('../assets/icons/lock.png'), // 用户冻结状态图标

  commandDelete: require('../assets/icons/mamDelete.png'), //  指令下达-删除
  commandEdit: require('../assets/icons/topicEdit.png'), //  指令下达-编辑

  commandReport: require('../assets/icons/commandReport.png'), //  指令接受-指令上报

  topicDelete: require('../assets/icons/topicDelete.png'), //  指挥策划列表-删除
  topicEdit: require('../assets/icons/topicEdit.png'), //  指挥策划列表-编辑
  taskAssign: require('../assets/icons/taskAssign.png'), //  指挥策划列表-派工

  siteDetail: require('../assets/icons/siteDetail.png'), //  站点-查看授权清单
  siteEdit: require('../assets/icons/siteEdit.png'), //  站点-修改
  siteDelete: require('../assets/icons/siteDelete.png'), //  站点-删除
  siteOpen: require('../assets/icons/siteOpen.png'), //  站点-启用
  siteClose: require('../assets/icons/siteClose.png'), //  站点-禁用
  setConfig: require('../assets/icons/61.png') //  设置栏目
}
//延后两秒执行，避免阻塞加载,无效处理，暂时注释--zxj
/*setTimeout(()=>{
  Object.keys(e5Icons).forEach((key) => {
    let image = new Image()
    image.src = e5Icons[key]
    image.onload = function() {
      e5Icons[key] = getBase64Image(image)
    }
  })
},2000)*/

export default e5Icons
